import { styled } from '@mui/material/styles'

/**
 * Resting fill for white-glyph controls floating over presentation content (the whiteboard's
 * canvas is white in every theme mode), so the glyph keeps its contrast whatever is underneath.
 */
export const VIDEO_OVERLAY_CONTROL_BG = 'rgba(0, 0, 0, 0.6)'

/**
 * Backing pill for a mic/camera toggle + its DeviceSelectMenu arrow, shared by the screenshare
 * and whiteboard control bars. The arrow inherits white, so it needs a dark surface to stay
 * visible over arbitrary content (a white whiteboard canvas, bright shared screens).
 * Fixed translucent black, matching the other video-overlay buttons, rather than a theme token.
 */
export const MediaControlGroup = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  color: 'white',
  padding: '2px 6px 2px 2px',
  borderRadius: '24px',
  backgroundColor: VIDEO_OVERLAY_CONTROL_BG,
})
